import React from 'react';
import GuestManagementTemp from './guestManagementTemp';
import Breadcrumbs from "../../../components/breadcrumbs";
import { Box, Typography } from "@mui/material";


const GuestManagement = () => {
    return (
        <>
            <Box p='30px'>
                <Breadcrumbs content={["Dashboard", "Guest Management"]} />
                <Box p='15px 0'>
                    <Typography variant='t24_700' > Guest Management </Typography>
                </Box>
                <GuestManagementTemp />
            </Box>
        </>
    )
}

export default GuestManagement;